import { render, staticRenderFns } from "./GameOptions.vue?vue&type=template&id=ce1153e8&scoped=true"
import script from "./GameOptions.vue?vue&type=script&lang=js"
export * from "./GameOptions.vue?vue&type=script&lang=js"
import style0 from "./GameOptions.vue?vue&type=style&index=0&id=ce1153e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1153e8",
  null
  
)

export default component.exports